// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3mFtf","label":"Completed_label___D_d0"};